import { createAsyncThunk } from '@reduxjs/toolkit';

import { getErrorMessage } from '@/shared/utils/error';
import type {
  CreateArbitroDto,
  PeriodoIndisponibilidade,
  PesoArbitroInput,
  UpdateArbitroDto,
  ArbitroStatus,
} from '@/types/arbitro/arbitroTypes';

import { arbitrosService } from './services';

export const buscarHistoricoArbitro = createAsyncThunk(
  'arbitros/buscarHistorico',
  async (id: string, { rejectWithValue }) => {
    try {
      return await arbitrosService.buscarHistorico(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const listarArbitros = createAsyncThunk(
  'arbitros/listar',
  async (_void: void, { rejectWithValue }) => {
    try {
      return await arbitrosService.listar();
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const listarEspecialidadesArbitrais = createAsyncThunk(
  'arbitros/listarEspecialidades',
  async (_void: void, { rejectWithValue }) => {
    try {
      return await arbitrosService.listarEspecialidades();
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const criarEspecialidade = createAsyncThunk(
  'arbitros/criarEspecialidade',
  async (nome: string, { rejectWithValue }) => {
    try {
      return await arbitrosService.criarEspecialidade(nome);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const renomearEspecialidade = createAsyncThunk(
  'arbitros/renomearEspecialidade',
  async ({ id, nome }: { id: string; nome: string }, { rejectWithValue }) => {
    try {
      return await arbitrosService.renomearEspecialidade(id, nome);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const alternarStatusEspecialidade = createAsyncThunk(
  'arbitros/alternarStatusEspecialidade',
  async (id: string, { rejectWithValue }) => {
    try {
      return await arbitrosService.alternarStatusEspecialidade(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const criarArbitro = createAsyncThunk(
  'arbitros/criar',
  async (data: CreateArbitroDto, { rejectWithValue }) => {
    try {
      return await arbitrosService.criar(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarArbitro = createAsyncThunk(
  'arbitros/atualizar',
  async ({ id, data }: { id: string; data: UpdateArbitroDto }, { rejectWithValue }) => {
    try {
      return await arbitrosService.atualizar(id, data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const alterarStatusArbitro = createAsyncThunk(
  'arbitros/alterarStatus',
  async ({ id, status }: { id: string; status: ArbitroStatus }, { rejectWithValue }) => {
    try {
      return await arbitrosService.alterarStatus(id, status);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const atualizarPesosArbitros = createAsyncThunk(
  'arbitros/atualizarPesos',
  async (pesos: PesoArbitroInput[], { rejectWithValue }) => {
    try {
      return await arbitrosService.atualizarPesos(pesos);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const registrarIndisponibilidadeArbitro = createAsyncThunk(
  'arbitros/registrarIndisponibilidade',
  async (
    { id, periodo }: { id: string; periodo: Omit<PeriodoIndisponibilidade, 'id'> },
    { rejectWithValue },
  ) => {
    try {
      return await arbitrosService.registrarIndisponibilidade(id, periodo);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const removerIndisponibilidadeArbitro = createAsyncThunk(
  'arbitros/removerIndisponibilidade',
  async ({ id, periodoId }: { id: string; periodoId: string }, { rejectWithValue }) => {
    try {
      return await arbitrosService.removerIndisponibilidade(id, periodoId);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const reenviarConviteArbitro = createAsyncThunk(
  'arbitros/reenviarConvite',
  async (id: string, { rejectWithValue }) => {
    try {
      return await arbitrosService.reenviarConvite(id);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);
